import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer, RefreshCw, Trash2 } from "lucide-react";
import { errMsg, timeMY } from "@/lib/api";

const STATE = {
  connected: ["Bersambung", "bg-green-100 text-green-700", "bg-green-500"],
  printer_off: ["Printer terputus", "bg-red-100 text-red-700", "bg-red-500"],
  offline: ["Peranti offline", "bg-slate-200 text-slate-600", "bg-slate-400"],
};

export function PrinterDevicesCard({ req }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => req("get", "/superadmin/printers").then(setRows).catch((e) => toast.error(errMsg(e))), [req]);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);
  const remove = async (d) => {
    if (!window.confirm(`Buang ${d.device_name || d.device_id} dari senarai?`)) return;
    try { await req("delete", `/superadmin/printers/${d.device_id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const bad = (rows || []).filter((r) => r.state !== "connected").length;

  return (
    <section className="bg-white rounded-2xl border p-6 space-y-4" data-testid="printer-devices-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-display font-bold flex items-center gap-2"><Printer className="w-5 h-5 text-red-700" />Status Printer Peranti <span className="text-[10px] px-2 py-0.5 rounded-full bg-amber-400 text-[#3B0A0A] font-bold">SUPERADMIN</span></h3>
        <div className="flex items-center gap-2">
          {rows && <span data-testid="printer-devices-summary" className={`text-[11px] px-2 py-0.5 rounded-full font-semibold ${bad ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>{bad ? `${bad} bermasalah` : "Semua OK"}</span>}
          <button onClick={load} data-testid="printer-devices-refresh" className="p-2 rounded-lg border hover:bg-slate-50"><RefreshCw className="w-4 h-4" /></button>
        </div>
      </div>
      <p className="text-xs text-slate-500">Setiap tablet/telefon yang buka POS melapor status printer setiap ~20 saat. Senarai dikemas kini setiap 15 saat.</p>
      {rows && rows.length === 0 && <p className="text-sm text-slate-500" data-testid="printer-devices-empty">Belum ada peranti POS melapor. Buka POS di tablet kedai.</p>}
      <div className="divide-y">
        {(rows || []).map((d) => {
          const [label, pill, dot] = STATE[d.state];
          return (
            <div key={d.device_id} className="py-3 flex items-center gap-3" data-testid={`printer-device-${d.device_id}`}>
              <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${dot}`} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{d.device_name || "Peranti"} · {d.user_name} <span className={`ml-1 text-[10px] px-1.5 py-0.5 rounded font-bold uppercase ${d.role === "dapur" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600"}`} data-testid={`printer-device-role-${d.device_id}`}>{d.role === "dapur" ? "Dapur" : "Kaunter"}</span></p>
                <p className="text-xs text-slate-500 truncate">{d.label || "-"} · {d.method || "-"} · dilihat {new Date(d.last_seen).toLocaleDateString("ms-MY")} {timeMY(d.last_seen)}</p>
                {d.kitchen_ok != null && <p className={`text-xs font-semibold ${d.kitchen_ok ? "text-green-700" : "text-red-600"}`} data-testid={`printer-device-kitchen-${d.device_id}`}>Printer dapur: {d.kitchen_label || (d.kitchen_ok ? "Bersambung" : "Tidak bersambung")}</p>}
              </div>
              <span className={`text-[11px] px-2 py-0.5 rounded-full font-semibold shrink-0 ${pill}`} data-testid={`printer-device-state-${d.device_id}`}>{label}</span>
              <button onClick={() => remove(d)} data-testid={`printer-device-delete-${d.device_id}`} className="p-1.5 rounded border hover:bg-red-50 text-red-600"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
